import React from 'react';

import b_ from 'b_';

import {Button} from 'client/common/components/lego';
import I18N from 'assets/i18n/brandlift-project';

import './payment-not-possible-popup.css';

const b = b_.with('payment-not-possible-popup');

const i18n = I18N.common.paymentNotPossible;

interface PaymentIsNotPossiblePopupProps {
    onClose: () => void;
}

export default function PaymentNotPossiblePopup({onClose}: PaymentIsNotPossiblePopupProps) {
    const handleClick = () => {
        onClose();
    };

    return (
        <div className={b()}>
            <h3 className={b('title')}>{i18n.title}</h3>
            <p className={b('description')}>
                {i18n.description}
            </p>
            <Button className={b('button')} view='dl-action' size='m' onClick={handleClick}>
                {i18n.closeBtn}
            </Button>
        </div>
    );
}